export const GET_MANUFACTURERS = 'manufacturers/GET_COLORS';
export const GET_MANUFACTURERS_SUCCESS = 'manufacturers/GET_COLORS_SUCCESS';
export const GET_MANUFACTURERS_ERROR = 'manufacturers/GET_COLORS_ERROR';
